
(function () {
    var directivesModule = angular.module('customeDirectivesModule');

    directivesModule.directive('npDocumentEmailFavorite', function () {
        return {
            restrict: 'E',
            replace: true,
            controller: ['$scope', '$http', controller],
            controllerAs: 'vm',
            templateUrl: '/app/shared/favoriteButton/documentEmailFavorite.html',
            scope: {
                documentId: '=',
                isEmailSubscribe: '='
            },
            link: function (scope, element, attr) {
               
            }
        };
    });

    function controller($scope, $http) {
        var vm = this;
        vm.translation = globalResources;

        if (vm.translation.SubscribeToChanges.indexOf('\n(CTRL + ALT + E)') <= 0) {
            vm.translation.SubscribeToChanges = vm.translation.SubscribeToChanges + '\n(CTRL + ALT + E)';
        }

        vm.addDocumetEmailSubscription = addDocumetEmailSubscription;
        vm.remoteDocumetEmailSubscription = remoteDocumetEmailSubscription;
        
        function addDocumetEmailSubscription() {
            var requestUrl = handbookRequests.AddEmailSubscriptionDocument + '/' + $scope.documentId;
            $http.post(requestUrl)
                   .then(function () {
                       $scope.isEmailSubscribe = !$scope.isEmailSubscribe;
                   });
        };

        function remoteDocumetEmailSubscription() {
            var requestUrl = handbookRequests.RemoveEmailSubscriptionDocument + '/' + $scope.documentId;
            $http.post(requestUrl)
                   .then(function () {
                       $scope.isEmailSubscribe = !$scope.isEmailSubscribe;
                   });
        };

        $scope.$on(broadcastType.toggleEmailSubscriptionTarget, function (e, target) {
            if (angular.element('#document-email-subscribe').hasClass('ng-hide')) {
                remoteDocumetEmailSubscription();
            } else {
                addDocumetEmailSubscription();
            }
        });
    }

})();